import styled from 'styled-components';

export const IntegrationTabStyle = styled.div`
  position: relative;
  font-size: 16px;
  line-height: 20px;
  color: var(--light-gray);

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    margin: 0 0 10px;
    color: var(--text-color);
  }

  .text-box {
    position: relative;
    flex-grow: 1;
    padding: 0 0 0 55px;

    .icon {
      position: absolute;
      top: 2px;
      left: 0;
      width: 45px;
    }
  }

  .holder {
    margin: 0 0 30px;

    &.flex-col {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
    }
  }
`;
